export const AMEND_LETTER_MAX_BYTES = 7 * 1024 * 1024;
export const AMEND_LETTER_ALLOWED_FILE_TYPES = [
    '.pdf',
    'application/pdf',
];
/**
 * Appends a short London calendar date before the extension.
 * `Doc1.pdf` is saved as `Doc1-20261014.pdf`. The upload id folder keeps the
 * storage key unique, so the shown name does not need a full timestamp.
 */
export function addAmendLetterDateSuffix(fileName, now = new Date()) {
    const stamp = amendLetterDateStamp(now);
    const lastDot = fileName.lastIndexOf('.');
    if (lastDot <= 0) {
        return `${fileName}-${stamp}`;
    }
    return `${fileName.slice(0, lastDot)}-${stamp}${fileName.slice(lastDot)}`;
}
function amendLetterDateStamp(now) {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(now);
    const year = parts.find((part) => part.type === 'year')?.value ?? '0000';
    const month = parts.find((part) => part.type === 'month')?.value ?? '00';
    const day = parts.find((part) => part.type === 'day')?.value ?? '00';
    return `${year}${month}${day}`;
}
export function sortAmendLetters(amendLetters) {
    if (!amendLetters) {
        return [];
    }
    return Object.values(amendLetters).sort((a, b) => (b.requestedAt || '').localeCompare(a.requestedAt || ''));
}
export function formatAmendLetterDate(value) {
    if (!value) {
        return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString('en-GB', {
        dateStyle: 'medium',
        timeStyle: 'short',
    });
}
